import { a as avatar, b as backdrop, c as button, d as buttonGroup, e as checkbox, f as checkboxGroup, g as chip, h as closeButton, i as divider, j as drawer, k as dropdownContent, l as formCheckbox, m as formCheckboxGroup, n as formDescription, o as formFeedback, p as formInput, q as formRadio, r as formRadioGroup, s as formSelect, t as formTextarea, u as input, v as label, w as listbox, x as listboxItem, y as modal, z as nativeSelect, A as notificationCard, B as notificationTransitions, C as notificationsContainer, D as overlay, E as overlayTransitions, F as popover, G as progressBar, H as radio, I as radioGroup, J as select, K as spinner, L as switchInput, M as textarea, N as toggleButton } from './forms-legacy-BfjJExaO.js';
export { O as twMerge } from './forms-legacy-BfjJExaO.js';
export { tv } from 'tailwind-variants';

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  avatar: avatar,
  backdrop: backdrop,
  button: button,
  buttonGroup: buttonGroup,
  checkbox: checkbox,
  checkboxGroup: checkboxGroup,
  chip: chip,
  closeButton: closeButton,
  divider: divider,
  drawer: drawer,
  dropdownContent: dropdownContent,
  formCheckbox: formCheckbox,
  formCheckboxGroup: formCheckboxGroup,
  formDescription: formDescription,
  formFeedback: formFeedback,
  formInput: formInput,
  formRadio: formRadio,
  formRadioGroup: formRadioGroup,
  formSelect: formSelect,
  formTextarea: formTextarea,
  input: input,
  label: label,
  listbox: listbox,
  listboxItem: listboxItem,
  modal: modal,
  nativeSelect: nativeSelect,
  notificationCard: notificationCard,
  notificationTransitions: notificationTransitions,
  notificationsContainer: notificationsContainer,
  overlay: overlay,
  overlayTransitions: overlayTransitions,
  popover: popover,
  progressBar: progressBar,
  radio: radio,
  radioGroup: radioGroup,
  select: select,
  spinner: spinner,
  switchInput: switchInput,
  textarea: textarea,
  toggleButton: toggleButton
});

let localStyles = components;
function registerCustomStyles(styles) {
  localStyles = {
    ...localStyles,
    ...styles
  };
}
function useStyles() {
  return localStyles;
}

export { registerCustomStyles, useStyles };
//# sourceMappingURL=index.js.map
